import React, { PureComponent } from 'react';

import OneVisualLayout from '../../../layouts/one-visual';
import ComposedGradientChart from '../../../components/composed-gradient-chart';

import { getRequest } from '../../../../../../api/ApiService';
import { decimalsRound } from "../../../../../../services/utils";

class RevenuesStep1 extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      data: []
    };
  }

  componentDidMount() {
    const { activeRound, rounds } = this.props;

    const round = rounds.find(i => Number(i.number) === Number(activeRound));
    const roundId = round ? round.id : 0;

    getRequest([
      `${process.env.REACT_APP_API_URL}v2/finance/metricsreports/?round=${roundId}`
    ]).then(res => {
      const metricsReports = res.body.results;

      const data = metricsReports.map(i => {
        return { value: Number(decimalsRound(i.net_revenues / 1000000, 2)) }
      });

      this.setState({
        data
      });
    })
      .catch(err => { });
  }

  render() {
    const { gamesTargets } = this.props;

    const { data } = this.state;

    return (
      <OneVisualLayout
        section="Why Targets Weren’t Hit"
        subSection="Revenues"
        title="Revenues Class Performance Overview"
        paragraph1={(
          <p>Here’s a snapshot of how much revenues each team generated in relation to the revenue target.</p>
        )}
        paragraph2={(
          <p>Let’s walk through some of the reasons why some teams were unable to hit their revenue target.</p>
        )}
        visual={(
          <ComposedGradientChart
            title="Revenues ($million)"
            data={data}
            lineData={decimalsRound(gamesTargets[0].net_revenues / 1000000, 2)}
            suffix="M"
          />
        )}
      />
    );
  }
}

export default RevenuesStep1;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/why-targets-werent-hit/revenues/step1.js